<script setup>
import { computed } from 'vue'

const props = defineProps({
    badgeClass: String,
    isNavigating: Boolean,
})

const isDev = computed(() => props.badgeClass === 'bg-badge-dev')

const pA = "M25.639,218.34l0,-21.343c76.237,0 138.132,-61.895 138.132,-138.132l21.517,0c10.337,1.241 18.563,9.389 19.923,19.689c-0.865,7.964 -2.248,15.773 -4.116,23.393c-15.958,65.113 -67.258,116.414 -132.371,132.372c-7.357,1.803 -14.889,3.155 -22.567,4.025l-0.127,-0c-10.63,-1.071 -19.122,-9.433 -20.391,-20.004Z"
const pB = "M163.107,327.902c15.959,-65.111 67.259,-116.41 132.371,-132.368c7.509,-1.84 15.203,-3.211 23.046,-4.078c10.464,1.218 18.782,9.513 20.037,19.966l0,21.435c-76.237,0 -138.132,61.895 -138.132,138.132l-21.17,0c-10.571,-1.269 -18.934,-9.761 -20.004,-20.391l-0,-1.604c0.872,-7.168 2.164,-14.208 3.852,-21.093Z"

const maskSvg = computed(() =>
    `url("data:image/svg+xml,${encodeURIComponent(`<svg viewBox="0 0 364 422" xmlns="http://www.w3.org/2000/svg"><path d="${pA}"/><path d="${pB}"/></svg>`)}")`
)

const barberStyle = computed(() => ({
    maskImage: maskSvg.value,
    WebkitMaskImage: maskSvg.value,
    maskSize: 'contain',
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    '--color-a': isDev.value ? '#e7bd35' : '#003cff',
    '--color-b': isDev.value ? '#fceea0' : '#93b4ff',
}))
</script>

<template>
    <div class="w-[51px] h-[50px] mb-8 relative">
        <div v-if="!isNavigating" :class="badgeClass" class="absolute inset-0 bg-contain bg-center bg-no-repeat" />
        <div v-else class="absolute inset-0 sidebar-barber" :style="barberStyle" />
    </div>
</template>

<style scoped>
.sidebar-barber {
    background: repeating-linear-gradient(
        -45deg,
        var(--color-a) 0px,
        var(--color-a) 8px,
        var(--color-b) 8px,
        var(--color-b) 16px
    );
    background-size: 22.63px 100%;
    animation: barber-move 0.45s linear infinite;
}

@keyframes barber-move {
    from { background-position-x: 0; }
    to   { background-position-x: 22.63px; }
}
</style>
